exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdownWrapper {\n  width: 100%;\n  min-width: 96px;\n}\n\n.dropdownWrapper .dropdown {\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);\n  position: absolute;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--2-4!./src/js/components/dropdownMenu/dropdown.scss
// module id = 373
// module chunks = 0